export default "__VITE_ASSET__o7_rsZVE__"